import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion.jsx";
import AddToCart from "@/components/cart/AddToCart.jsx";
import ProductImageGallery from "@/components/products/ProductImageGallery/ProductImageGallery.jsx";
import { useState } from "react";
import { Head } from "@inertiajs/react";
import pageTitle from "@/utils/pageTitle";
import formatMoney from "@/utils/formatMoney";

export default function Show({ product }) {
  const { gallery } = product;
  const images = gallery.map((g) => g.image);
  const [image] = images;
  const thumbnails = gallery.map((g) => g.thumbnail);

  const taxon = product.taxons.sort((t1, t2) => t1.depth - t2.depth).at(-1);
  const title = [
    product.name,
    `${product.price} руб.`,
    taxon?.meta_title || taxon?.pretty_name || taxon?.name,
  ]
    .filter((el) => !!el)
    .join(" | ");

  const description =
    product.meta_description || product.meta_title || product.name;

  const [isGalleryOpened, setIsGalleryOpened] = useState(false);

  return (
    <>
      <Head title={pageTitle(title)}>
        <meta name="description" content={description} />
      </Head>

      <div className="container mx-auto px-4 xl:px-0 py-16" itemScope itemType="http://schema.org/Product">
        <div className="flex flex-wrap">
          <div className="w-full xl:w-1/2 xl:pr-16 ">
            <ProductImageGallery
              images={gallery}
              open={isGalleryOpened}
              onClose={() => {
                setIsGalleryOpened(false);
              }}
            />
            <div className="flex justify-center w-full">
              <img
                src={image.url}
                className="size-full"
                onClick={() => setIsGalleryOpened(true)}
              />
            </div>

            <div className="flex space-x-2 pt-4">
              {thumbnails.length > 1 &&
                thumbnails.map((image) => {
                  return (
                    <img
                      src={image.url}
                      className="size-16 rounded border"
                      onClick={() => setIsGalleryOpened(true)}
                    />
                  );
                })}
            </div>
          </div>
          <div className="w-full xl:w-1/2 space-y-8 pt-8">
            <h1 className="text-4xl font-medium" itemProp="name">{product.name}</h1>
            <div className="flex items-center gap-4 justify-between xl:justify-start">
              <div className="text-2xl font-medium" itemProp="offers" itemScope itemType="http://schema.org/Offer">
                <span itemProp="price">{formatMoney(product.price)}</span>
                <span className="invisible" itemProp="priceCurrency">RUB</span>
              </div>
              <div>
                <AddToCart product={product} />
              </div>
            </div>

            <Accordion type="multiple" defaultValue={["description"]}>
              <AccordionItem value="description">
                <AccordionTrigger>Описание</AccordionTrigger>
                <AccordionContent className="text-lg">
                  <div itemProp="description">
                    {product.description || product.name}
                  </div>
                </AccordionContent>
              </AccordionItem>

              {/* <AccordionItem value="properties">
                <AccordionTrigger>Свойства</AccordionTrigger>
                <AccordionContent className="text-lg">
                  <ProductProperties
                    product_properties={product.product_properties}
                  />
                </AccordionContent>
              </AccordionItem> */}
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
}

function ProductProperties({ product_properties }) {
  return (
    <ul>
      {product_properties.map((pp) => {
        return (
          <li>
            {pp.property.presentation}: {pp.value}
          </li>
        );
      })}
    </ul>
  );
}
